import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ApproachLighting } from '../models/approach-lighting.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { RunwayService } from '../service/runway.service';
var EditAreaLightingComponent = /** @class */ (function () {
    function EditAreaLightingComponent(_matDialogRef, _snackBar, data, _runwayService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._runwayService = _runwayService;
        this.isLoading = true;
        this.isNew = false;
        this.lighting = data.lighting || new ApproachLighting();
        this.isNew = data.isNew || false;
        this.origLighting = Object.assign(new ApproachLighting(), data.lighting);
        this.airportId = data.airportId;
        this.takeoffLandAreaId = data.takeoffLandAreaId;
        if (data.isNew) {
            this.selectedLightingType = '';
        }
        else {
            this.selectedLightingType = this.getSelectedLightingType(this.lighting.type);
        }
    }
    EditAreaLightingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            lightingType: new FormControl(this.selectedLightingType, [Validators.required]),
            description: new FormControl(this.lighting.description, [Validators.maxLength(4000)])
        });
        this.isLoading = false;
    };
    EditAreaLightingComponent.prototype.getSelectedLightingType = function (type) {
        return ApproachLighting.formatApproachLightingType(type);
    };
    EditAreaLightingComponent.prototype.setSelectedLightingType = function (type) {
        return ApproachLighting.parseApproachLightingType(type);
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditAreaLightingComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        result = void 0;
                        this.lighting.takeoffLandAreaId = this.takeoffLandAreaId;
                        this.lighting.type = this.setSelectedLightingType(this.formGroup.value.lightingType);
                        this.lighting.description = this.formGroup.value.description;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._runwayService.postLighting(this.airportId, this.lighting)];
                    case 1:
                        result = _a.sent();
                        this.lighting = ApproachLighting.parse(result);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._runwayService.putLighting(this.airportId, this.lighting)];
                    case 3:
                        result = _a.sent();
                        this.lighting = ApproachLighting.parse(result);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, lighting: this.lighting });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false, error: e_1 });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditAreaLightingComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditAreaLightingComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.lighting, this.origLighting);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditAreaLightingComponent;
}());
export { EditAreaLightingComponent };
